const cityListResources = {
  en: {
    translation: {
      Almaty: 'Almaty',
      Astana: 'Astana',
      Taraz: 'Taraz',
      Shymkent: 'Shymkent',
      'Ust-Kamenogorsk': 'Ust-Kamenogorsk',
      Aktau: 'Aktau',
      Atyrau: 'Atyrau',
      Aktobe: 'Aktobe',
      Pavlodar: 'Pavlodar',
      Petropavlovsk: 'Petropavlovsk',
      Kokshetau: 'Kokshetau',
      Kyzylorda: 'Kyzylorda',
      Karaganda: 'Karaganda',
      Semey: 'Semey',
      Kostanay: 'Kostanay',
      Taldykorgan: 'Taldykorgan',
      Uralsk: 'Uralsk',
      Zheszkazgan: 'Zheszkazgan',
      'Abay Region': 'Abay Region',
      'Zhetysu Region': 'Zhetysu Region',
      'Akmola Region': 'Akmola Region',
      'Aktobe Region': 'Aktobe Region',
      'Atyrau Region': 'Atyrau Region',
      'Ulytau Region': 'Ulytau Region',
      'East Kazakhstan Region': 'East Kazakhstan Region',
      'Zhambyl Region': 'Zhambyl Region',
      'West Kazakhstan Region': 'West Kazakhstan Region',
      'Karagandy Region': 'Karagandy Region',
      'Kostanay Region': 'Kostanay Region',
      'Kyzylorda Region': 'Kyzylorda Region',
      'Mangystau Region': 'Mangystau Region',
      'Pavlodar Region': 'Pavlodar Region',
      'North Kazakhstan Region': 'North Kazakhstan Region',
      'South Kazakhstan Region': 'South Kazakhstan Region',
      Aksai: 'Aksai',
      'Almaty Region': 'Almaty Region',
      Balkhash: 'Balkhash',
      Chunzha: 'Chunzha',
      Esik: 'Esik',
      'Far Abroad': 'Far Abroad',
      Kandyagash: 'Kandyagash',
      'Karaganda Region': 'Karaganda Region',
      Khromtau: 'Khromtau',
      Kunaev: 'Kunaev',
      'Mangistau Region': 'Mangistau Region',
      'Near Abroad': 'Near Abroad',
      Satpayev: 'Satpayev',
      Shalkar: 'Shalkar',
      Shuchinsk: 'Shuchinsk',
      Talgar: 'Talgar',
      Temirtau: 'Temirtau',
      'Turkestan Region': 'Turkestan Region',
      Zharkent: 'Zharkent',
      Stepnogorsk: 'Stepnogorsk',
      'Алматинская область': 'Алматинская область',
      'Восточно-Казахстанская область': 'Восточно-Казахстанская область',
      'Костанайская область': 'Костанайская область',
      'Карагандинская область': 'Карагандинская область',
      'Северо-Казахстанская область': 'Северо-Казахстанская область',
      'Акмолинская область': 'Акмолинская область',
      'Павлодарская область': 'Павлодарская область ',
      'Жамбылская область': 'Жамбылская область ',
      'Актюбинская область': 'Актюбинская область',
      'Западно-Казахстанская область': 'Западно-Казахстанская область',
      'Кылординская область': 'Кызылординская область',
      'Атырауская область': 'Атырауская область',
      'Мангистауская область': 'Мангистауская область',
      Алматы: 'Алматы',
      Астана: 'Астана',
      Шымкент: 'Шымкент',
      'Туркестанская область': 'Туркестанская область',
      'Абайская область': 'Абайская область',
      'Жетысуйская область': 'Жетысуйская область',
      'Улытауская область': 'Улытауская область',
    },
  },
  kz: {
    translation: {
      Almaty: 'Алматы',
      Astana: 'Астана',
      Taraz: 'Тараз',
      Shymkent: 'Шымкент',
      'Ust-Kamenogorsk': 'Өскемен',
      Aktau: 'Ақтау',
      Atyrau: 'Атырау',
      Aktobe: 'Ақтөбе',
      Pavlodar: 'Павлодар',
      Petropavlovsk: 'Петропавловск',
      Kokshetau: 'Көкшетау',
      Kyzylorda: 'Қызылорда',
      Karaganda: 'Қарағанды',
      Semey: 'Семей',
      Kostanay: 'Қостанай',
      Taldykorgan: 'Талдықорған',
      Uralsk: 'Орал',
      Zheszkazgan: 'Жезқазған',
      'Abay Region': 'Абай облысы',
      'Zhetysu Region': 'Жетісу облысы',
      'Akmola Region': 'Ақмола облысы',
      'Aktobe Region': 'Ақтөбе облысы',
      'Atyrau Region': 'Атырау облысы',
      'Ulytau Region': 'Ұлытау облысы',
      'East Kazakhstan Region': 'Шығыс Қазақстан облысы',
      'Zhambyl Region': 'Жамбыл облысы',
      'West Kazakhstan Region': 'Батыс Қазақстан облысы',
      'Karagandy Region': 'Қарағанды облысы',
      'Kostanay Region': 'Қостанай облысы',
      'Kyzylorda Region': 'Қызылорда облысы',
      'Mangystau Region': 'Мангыстау облысы',
      'Pavlodar Region': 'Павлодар облысы',
      'North Kazakhstan Region': 'Солтүстік Қазақстан облысы',
      'South Kazakhstan Region': 'Оңтүстік Қазақстан облысы',
      Aksai: 'Ақсай',
      'Almaty Region': 'Алматы облысы',
      Balkhash: 'Балқаш',
      Chunzha: 'Шонжы',
      Esik: 'Есік',
      'Far Abroad': 'Алыс Шығыс',
      Kandyagash: 'Қандыағаш',
      'Karaganda Region': 'Қарағанды облысы',
      Khromtau: 'Хромтау',
      Kunaev: 'Қонаев',
      'Mangistau Region': 'Маңғыстау облысы',
      'Near Abroad': 'Жақын Шығыс',
      Satpayev: 'Сәтпаев',
      Shalkar: 'Шалқар',
      Shuchinsk: 'Щучинск',
      Talgar: 'Талғар',
      Temirtau: 'Теміртау',
      'Turkestan Region': 'Түркістан облысы',
      Zharkent: 'Жаркент',
      Stepnogorsk: 'Степногорск',
      'Алматинская область': 'Алматы облысы',
      'Восточно-Казахстанская область': 'Шығыс Қазақстан облысы',
      'Костанайская область': 'Қостанай облысы',
      'Карагандинская область': 'Қарағанды облысы',
      'Северо-Казахстанская область': 'Солтүстік Қазақстан облысы',
      'Акмолинская область': 'Ақмола облысы',
      'Павлодарская область': 'Павлодар облысы ',
      'Жамбылская область': 'Жамбыл облысы ',
      'Актюбинская область': 'Ақтөбе облысы',
      'Западно-Казахстанская область': 'Батыс Қазақстан облысы',
      'Кылординская область': 'Қызылорда облысы',
      'Атырауская область': 'Атырау облысы',
      'Мангистауская область': 'Маңғыстау облысы',
      Алматы: 'Алматы',
      Астана: 'Астана',
      Шымкент: 'Шымкент',
      'Туркестанская область': 'Түркістан облысы',
      'Абайская область': 'Абай облысы',
      'Жетысуйская область': 'Жетісу облысы',
      'Улытауская область': 'Ұлытау облысы',
    },
  },
  ru: {
    translation: {
      Almaty: 'Алматы',
      Astana: 'Астана',
      Taraz: 'Тараз',
      Shymkent: 'Шымкент',
      'Ust-Kamenogorsk': 'Усть-Каменогорск',
      Aktau: 'Актау',
      Atyrau: 'Атырау',
      Aktobe: 'Актобе',
      Pavlodar: 'Павлодар',
      Petropavlovsk: 'Петропавловск',
      Kokshetau: 'Кокшетау',
      Kyzylorda: 'Кызылорда',
      Karaganda: 'Караганда',
      Semey: 'Семей',
      Kostanay: 'Костанай',
      Taldykorgan: 'Талдыкорган',
      Uralsk: 'Уральск',
      Zheszkazgan: 'Жезказган',
      'Abay Region': 'Абай область',
      'Zhetysu Region': 'Жетысуская область',
      'Akmola Region': 'Акмолинская область',
      'Aktobe Region': 'Актюбинская область',
      'Atyrau Region': 'Атырауская область',
      'Ulytau Region': 'Улытауская область',
      'East Kazakhstan Region': 'Восточно-Казахстанская область',
      'Zhambyl Region': 'Жамбылская область',
      'West Kazakhstan Region': 'Западно-Казахстанская область',
      'Karagandy Region': 'Карагандинская область',
      'Kostanay Region': 'Костанайская область',
      'Kyzylorda Region': 'Кызылординская область',
      'Mangystau Region': 'Мангистауская область',
      'Pavlodar Region': 'Павлодарская область',
      'North Kazakhstan Region': 'Северо-Казахстанская область',
      'South Kazakhstan Region': 'Шымкент',
      Aksai: 'Аксай',
      'Almaty Region': 'Алматинская область',
      Balkhash: 'Балхаш',
      Chunzha: 'Чунджа',
      Esik: 'Есик',
      'Far Abroad': 'Дальнее зарубежье',
      Kandyagash: 'Кандыагаш',
      'Karaganda Region': 'Карагандинская область',
      Khromtau: 'Хромтау',
      Kunaev: 'Кунаев',
      'Mangistau Region': 'Мангистауская область',
      'Near Abroad': 'Ближнее зарубежье',
      Satpayev: 'Сатпаев',
      Shalkar: 'Шалкар',
      Shuchinsk: 'Щучинск',
      Talgar: 'Талгар',
      Temirtau: 'Темиртау',
      'Turkestan Region': 'Туркестанская область',
      Zharkent: 'Жаркент',
      Stepnogorsk: 'Степногорск',
      'Алматинская область': 'Алматинская область',
      'Восточно-Казахстанская область': 'Восточно-Казахстанская область',
      'Костанайская область': 'Костанайская область',
      'Карагандинская область': 'Карагандинская область',
      'Северо-Казахстанская область': 'Северо-Казахстанская область',
      'Акмолинская область': 'Акмолинская область',
      'Павлодарская область': 'Павлодарская область ',
      'Жамбылская область': 'Жамбылская область ',
      'Актюбинская область': 'Актюбинская область',
      'Западно-Казахстанская область': 'Западно-Казахстанская область',
      'Кылординская область': 'Кызылординская область',
      'Атырауская область': 'Атырауская область',
      'Мангистауская область': 'Мангистауская область',
      Алматы: 'Алматы',
      Астана: 'Астана',
      Шымкент: 'Шымкент',
      'Туркестанская область': 'Туркестанская область',
      'Абайская область': 'Абайская область',
      'Жетысуйская область': 'Жетысуйская область',
      'Улытауская область': 'Улытауская область',
    },
  },
};

export default cityListResources;
